<template>
  <div class="playersList">
    <!-- 页头 -->
    <div class="page-header-style">
      <el-page-header @back="goBack" :content="$t('lang.title_playersList')"></el-page-header>
    </div>
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 性别select -->
        <el-form-item :label="$t('lang.lab_gender')">
          <el-select v-model="gender" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_gender')">
            <el-option
              v-for="(item,index) in genders"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 代表队select -->
        <el-form-item :label="$t('lang.lab_delegation')">
          <el-select v-model="delegationId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_delegation')">
            <el-option
              v-for="(item,index) in delegations"
              :key="index"
              :value="item.id"
              :label="item.teamName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 赛事项目select -->
        <el-form-item :label="$t('lang.lab_competeItem')">
          <el-select v-model="competeItemId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeItem')">
            <el-option
              v-for="(item,index) in competeNames"
              :key="index"
              :value="item.id"
              :label="item.itemName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 状态select -->
        <el-form-item :label="$t('lang.lab_enrollStatus')">
          <el-select v-model="state" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_enrollStatus')">
            <el-option
              v-for="(item,index) in states"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <br/>
        <!-- 姓名input -->
        <el-form-item :label="$t('lang.lab_name')">
          <input style="display: none"/>
          <el-input v-model="name" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_name')"></el-input>
        </el-form-item>
        <!-- 证件号input -->
        <el-form-item :label="$t('lang.lab_certificateNum')">
          <input style="display: none"/>
          <el-input v-model="certificateNum" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_certificateNum')"></el-input>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 数据导出 -->
      <el-button type="primary" slot="header" @click="onExport">{{$t('lang.btn_exportData')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @sort-change="changeTableSort"
      >
        <!-- 姓名 -->
        <el-table-column prop="name" :label="$t('lang.lab_name')" :sortable="'custom'"></el-table-column>
        <!-- 性别 -->
        <el-table-column prop="gender" :label="$t('lang.lab_gender')" :sortable="'custom'">
        </el-table-column>
        <!-- 年龄 -->
        <el-table-column prop="age" :label="$t('lang.lab_age')" :sortable="'custom'"></el-table-column>
        <!-- 代表队 -->
        <el-table-column prop="teamName" :label="$t('lang.lab_delegation')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.teamName | valueIsNull}}</span>
          </template>
        </el-table-column>
        <!-- 赛事项目 -->
        <el-table-column prop="competeItemName" :label="$t('lang.lab_competeItem')" :sortable="'custom'" width="210px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.competeItemName&&scope.row.competeItemName.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.competeItemName }}
                </span>
              </div>
              <div>
                {{ scope.row.competeItemName.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.competeItemName.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.competeItemName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column prop="enrollStatus" :label="$t('lang.lab_enrollStatus')" :sortable="'custom'">
          <template slot-scope="scope">
            <!-- 0: 取消报名 -->
            <span v-if="scope.row.enrollStatus === false">{{$t('lang.Players_enrollStatus[1].name')}}</span>
            <!-- 1: 报名成功 -->
            <span v-if="scope.row.enrollStatus === true">{{$t('lang.Players_enrollStatus[2].name')}}</span>
          </template>
        </el-table-column>
        <!-- 已缴费用(元) -->
        <el-table-column prop="paidFee" :label="$t('lang.lab_paidFee')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.paidFee | valueIsNull}}</span>
          </template>
        </el-table-column>
        <!-- 收费方式 -->
        <el-table-column prop="paidFee" :label="$t('lang.lab_paidChargeMethod')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.payTeam!==null?'按人':'按项目'}}</span>
          </template>
        </el-table-column>
        <!-- 证件类型 -->
        <el-table-column prop="idType" :label="$t('lang.lab_certificateType')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{scope.row.idType.replace(new RegExp('0','g'),$t('lang.MeetingRecordDetail_idType[0].name')).replace(new RegExp('1','g'),$t('lang.MeetingRecordDetail_idType[1].name')).replace(new RegExp('2','g'),$t('lang.MeetingRecordDetail_idType[2].name')).replace(new RegExp('3','g'),$t('lang.MeetingRecordDetail_idType[3].name'))}}</span>
            <!-- 0: 身份证 -->
            <!-- <span v-if="scope.row.idType === '0'">{{$t('lang.MeetingRecordDetail_idType[0].name')}}</span> -->
            <!-- 1: 护照 -->
            <!-- <span v-if="scope.row.idType === '1'">{{$t('lang.MeetingRecordDetail_idType[1].name')}}</span> -->
            <!-- 2: 港澳身份证 -->
            <!-- <span v-if="scope.row.idType === '2'">{{$t('lang.MeetingRecordDetail_idType[2].name')}}</span> -->
            <!-- 3: 台胞证 -->
            <!-- <span v-if="scope.row.idType === '3'">{{$t('lang.MeetingRecordDetail_idType[3].name')}}</span> -->
          </template>
        </el-table-column>
        <!-- 证件号 -->
        <el-table-column prop="idCard" :label="$t('lang.lab_certificateNum')" :sortable="'custom'" width="200"></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" width="180px">
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button @click="onDetail(scope.row.idCard)">{{$t('lang.btn_detail')}}</el-button>
            <!-- 仅退费 -->
            <el-button v-if="scope.row.deposit === false" @click="onRefund(scope.row)">{{$t('lang.lab_onlyRefund')}}</el-button>
            <!-- 取消报名 -->
            <el-button v-if="scope.row.enrollStatus === true" @click="onCancel(scope.row)">{{$t('lang.lab_cancelEnroll')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:playersList
 *@Description:选手列表
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-14
 */
import { excelDownload } from '../../config/download.js'

export default {
  name: '',
  components: {},
  data() {
    return {
      competeId: '', // 通过id查找某个赛事的选手列表
      competeName: '', // 赛事名称
      /* 选手列表变量 */
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      genders: this.$i18n.t('lang.Players_gender'), // 性别下拉list
      states: this.$i18n.t('lang.Players_enrollStatus'), // 状态下拉list
      delegations: [], // 代表队下拉list
      competeNames: [], // 赛事项目下拉list
      gender: '', // 筛选-性别
      state: '', // 筛选-状态
      delegationId: '', // 筛选-代表队
      competeItemId: '', // 筛选-赛事项目
      name: '', // 筛选-姓名
      wechat: '', // 筛选-报名微信
      certificateNum: '', // 筛选-证件号
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 选手列表数据
      /* 记忆筛选项值 */
      competeItemId_bak: '', // 备份-赛事项目
      state_bak: '', // 备份-状态
      gender_bak: '', // 备份-性别
      delegationId_bak: '', // 备份-代表队
      name_bak: '', // 备份-姓名
      wechat_bak: '', // 备份-报名微信
      certificateNum_bak: '', // 备份-证件号
      /* 数据导出 */
      allData: [], 
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 获取选手列表数据
    getData() {
      let params = {
        competeId: this.competeId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$postJson('/player/offLine/playerList', params).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取代表队下拉list
    getDelegationList() {
      this.$get(`/compete/team?competeId=${this.competeId}`).then(
        res => {
          if (res && res.code === 200) {
            this.delegations = res.data
            let newValue = {
              id: '',
              teamName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_delegation')
            }
            this.delegations.unshift(newValue)   
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取赛事项目下拉list
    getCompeteList() {
      this.$get(`/item/compete/filterItem?competeId=${this.competeId}`).then(
        res => {
          if (res && res.code === 200) {
            this.competeNames = res.data.list
            let newValue = {
              id: '',
              itemName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeItem')
            }
            this.competeNames.unshift(newValue)  
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
      if (isSearch) {
        // 记忆筛选项值
        this.competeItemId_bak = this.competeItemId
        this.state_bak = this.state
        this.gender_bak = this.gender
        this.delegationId_bak = this.delegationId
        this.name_bak = this.name
        this.wechat_bak = this.wechat
        this.certificateNum_bak = this.certificateNum
      } else { 
        // 筛选项正确显示
        this.competeItemId = this.competeItemId_bak
        this.state = this.state_bak
        this.gender = this.gender_bak
        this.delegationId = this.delegationId_bak
        this.name = this.name_bak
        this.wechat = this.wechat_bak
        this.certificateNum = this.certificateNum_bak
      }
      let params = {
        competeId: this.competeId,
        competeItemId: this.competeItemId,
        enrollStatus: this.state,
        gender: this.gender,
        teamId: this.delegationId,
        name: this.name,
        weChatAccount: this.wechat,
        idCard: this.certificateNum,
        sortName: this.sortName,
        sortFieldName: this.sortFieldName,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$postJson('/player/offLine/playerList', params).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 重置
    onClear() {
      this.competeItemId = ''
      this.state = ''
      this.gender = ''
      this.delegationId = ''
      this.name = ''
      this.wechat = ''
      this.certificateNum = ''
      this.competeItemId_bak = ''
      this.state_bak = ''
      this.gender_bak = ''
      this.delegationId_bak = ''
      this.name_bak = ''
      this.wechat_bak = ''
      this.certificateNum_bak = ''
      this.sortName = ''
      this.sortFieldName = ''
      this.pageNum = 1
      this.getData()
    },
    // 查看
    onDetail(id) {
      console.log('onDetail', id)
      this.$router.push({ name: 'playerInfo', query: { idCard: id, source: 2 } })
    },
    // 取消报名
    onCancel(data) {
      let loading = this.$loading()
      let confirmLabel = ''
      // 按照个人收费 -文言修改
      if (data.payTeam !== null) {
        confirmLabel = '此操作会关联同时缴费的其他报名项目，请确认您的操作。\n' + this.$i18n.t('lang.lab_isCancelEnroll')
      } else { // 按照项目收费-保持原文言不变
        confirmLabel = this.$i18n.t('lang.lab_isCancelEnroll')
      }
      this.$confirm(confirmLabel, this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => { 
          let array = []
          array.push(data.playerId)
          let type = ''
          if (data.enrollType === 'team') {
            type = 'single'
          } else {
            type = data.enrollType
          }
          let params = {
            competeId: data.competeId,
            competeItemId: data.competeItemId,
            openId: data.openId,
            playerId: array,
            type: type
          }    
          this.$postJson('/my/offLine/closeEnroll', params).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_successOperation')
                })
                // 更新tableData
                this.onSearch(false, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_cancelOperation')
          })
        })  
    },
    // 仅退赛
    onRefund(data) {
      let loading = this.$loading()
      let confirmLabel = ''
      // 按照个人收费 -文言修改
      if (data.payTeam !== null) {
        confirmLabel = '此操作会关联同时缴费的其他报名项目，请确认您的操作。' + this.$i18n.t('lang.lab_isOnlyRefund1') + data.name + this.$i18n.t('lang.lab_isOnlyRefund2') 
      } else { // 按照项目收费-保持原文言不变
        confirmLabel = this.$i18n.t('lang.lab_isOnlyRefund1') + data.name + this.$i18n.t('lang.lab_isOnlyRefund2')
      }
      // this.$confirm(this.$i18n.t('lang.lab_isOnlyRefund1') + data.name + this.$i18n.t('lang.lab_isOnlyRefund2'), this.$i18n.t('lang.lab_prompt'),
      this.$confirm(confirmLabel, this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => { 
          let array = []
          array.push(data.playerId)
          let type = ''
          if (data.enrollType === 'team') {
            type = 'single'
          } else {
            type = data.enrollType
          }
          let params = {
            competeId: data.competeId,
            competeItemId: data.competeItemId,
            openId: data.openId,
            playerId: array,
            type: type
          }    
          this.$postJson('/my/offLine/refundDeposit', params).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_successOperation')
                })
                // 更新tableData
                this.onSearch(false, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_cancelOperation')
          })
        })  
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true, false)
    },
    // 获取全部数据
    getAllData() {
      // 筛选项正确显示
      this.competeItemId = this.competeItemId_bak
      this.state = this.state_bak
      this.gender = this.gender_bak
      this.delegationId = this.delegationId_bak
      this.name = this.name_bak
      this.wechat = this.wechat_bak
      this.certificateNum = this.certificateNum_bak
      let params = {
        competeId: this.competeId,
        competeItemId: this.competeItemId,
        enrollStatus: this.state,
        gender: this.gender,
        teamId: this.delegationId,
        name: this.name,
        weChatAccount: this.wechat,
        idCard: this.certificateNum,
        sortName: this.sortName,
        sortFieldName: this.sortFieldName,
      }
      let loading = this.$loading()
      this.$postJson('/player/offLine/playerList', params).then(
        res => {
          loading.close()
          if (res && res.code === 200) {
            this.allData = res.data.list
            let newArr = []
            let index = ''
            let gender = ''
            let enrollStatus = ''
            let type = ''
            if (this.allData.length > 0) {
              for (let i = 0; i < this.allData.length; i++) {
                index = i + 1
                // 判断性别
                gender = this.allData[i].gender
                // if (this.allData[i].gender === 0) {
                //   gender = this.$i18n.t('lang.Players_gender[1].name')
                // } else {
                //   gender = this.$i18n.t('lang.Players_gender[2].name')
                // }
                // 判断状态
                if (this.allData[i].enrollStatus === false) {
                  enrollStatus = this.$i18n.t('lang.Players_enrollStatus[1].name')
                } else {
                  enrollStatus = this.$i18n.t('lang.Players_enrollStatus[2].name')
                }
                // 判断证件类型
                if (this.allData[i].idType === '0') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[0].name')
                } else if (this.allData[i].idType === '1') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[1].name')
                } else if (this.allData[i].idType === '2') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[2].name')
                } else if (this.allData[i].idType === '3') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[3].name')
                } 
                newArr.push({
                  index: index,
                  name: this.allData[i].name,
                  gender: gender,
                  age: this.allData[i].age,
                  birthday: this.allData[i].birthday,
                  teamName: this.allData[i].teamName,
                  competeItemName: this.allData[i].competeItemName,
                  groupNum: this.allData[i].groupNum,
                  swimLane: this.allData[i].swimLane,
                  enrollStatus: enrollStatus,
                  paidFee: this.allData[i].paidFee,
                  phone: this.allData[i].phone,
                  idType: type,
                  idCard: this.allData[i].idCard,
                })
              }
            }
            // Excel表头
            const tHeader = [
              this.$i18n.t('lang.lab_index'),
              this.$i18n.t('lang.lab_name'),
              this.$i18n.t('lang.lab_gender'),
              this.$i18n.t('lang.lab_age'),
              this.$i18n.t('lang.lab_birthday'),
              this.$i18n.t('lang.lab_delegation'),
              this.$i18n.t('lang.lab_enrollStatus'),
              this.$i18n.t('lang.lab_competeItem'),
              this.$i18n.t('lang.lab_group'),
              this.$i18n.t('lang.lab_swimLane'),
              this.$i18n.t('lang.lab_paidFee'),
              this.$i18n.t('lang.lab_phone'),
              this.$i18n.t('lang.lab_certificateType'),
              this.$i18n.t('lang.lab_certificateNum'),
            ]
            // 对应table数据的列字段名
            const filterVal = [
              'index',
              'name',
              'gender',
              'age',
              'birthday',
              'teamName',
              'enrollStatus',
              'competeItemName',
              'groupNum',
              'swimLane',
              'paidFee',
              'phone',
              'idType',
              'idCard',
            ]
            excelDownload(tHeader, filterVal, newArr, this.competeName + this.$i18n.t('lang.lab_playersList'))
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 数据导出
    onExport() {
      if (navigator.onLine) {
        this.getAllData()
      } else {
        this.$message.error(this.$i18n.t('lang.warning_network'))
      }      
    },
    // 返回
    goBack() {
      window.history.go(-1)
    }
  },
  created() {
    this.competeId = this.$route.query.id
    this.competeName = this.$route.query.competeName
    if (this.competeId !== '') {
      this.getData()
      this.getDelegationList()
      this.getCompeteList()
    }
  },
  mounted() {}
}
</script>

<style lang='scss'>
.playersList{
  .el-tooltip__popper.is-light {
    max-width: 300px;
  }
}
</style>
